module.exports = __webpack_public_path__ + "static/media/rose.83731cf9.png";